import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import {
  TablePadrão,
  Td,
  Tr,
} from '../../../../components/develop-nilton-components/TablePadrão';
import { Pagination } from '../../../../components/Pagination';
import { SpinnerLoading } from '../../../../components/SpinnerLoading';
import { TbodyGeralPageAddRoundsEgresses } from './TbodyGeralPageAddRoundsEgresses';
import { IEgresses } from '../../../../types/IEgresses';

type PropsTableGeralRoundEgresses = {
  egresses: any;
  handleSetEgresses(page?: number): Promise<void> | void;
  useStateCheckboxAll: [any, React.Dispatch<any>];
  loadEgress: boolean;
  useStateEgresse: [IEgresses | null, (egresse: IEgresses | null) => void];
  useStateIsOpen: [boolean, (boolean: boolean) => void];
};

export function TableGeralRoundEgresses({
  egresses,
  handleSetEgresses,
  useStateCheckboxAll,
  loadEgress,
  useStateEgresse,
  useStateIsOpen,
}: PropsTableGeralRoundEgresses) {
  const headWidth = ['5%', '85%', '10%'];
  const { state } = useLocation<any>();
  const [checkboxAll, setCheckboxAll] = useStateCheckboxAll;

  const [checked, setChecked] = useState(false);
  const [listEgresses, setListEgresses] = useState([]);
  const [egresse, setEgresse] = useStateEgresse;
  const [isWatchEgresse, setIsWatchEgresse] = useStateIsOpen;

  useEffect(() => {
    setChecked(false);
  }, [loadEgress]);

  function handleCheckedAll(e: any) {
    setChecked(!checked);
    setCheckboxAll(
      checkboxAll?.map((item: any) => ({ ...item, checked: e.target.checked })),
    );
  }

  function handleChecked(egress_id: number) {
    setCheckboxAll(
      checkboxAll?.map((item: any) =>
        item.egress_id === egress_id
          ? { ...item, checked: !item.checked }
          : item,
      ),
    );
  }

  useEffect(() => {
    setListEgresses(
      egresses?.data.filter((item: any) => item.habilitado === 'T'),
    );
    setCheckboxAll(
      egresses?.data
        .filter(
          (item: any) =>
            item.habilitado === 'T' && // Validation for habilitado === 'T'
            item.inRound.length === 0 &&
            item.endereco.filter((addr: any) => addr.atual).length !== 0,
        )
        .map((item: any) => ({
          round_id: state.id,
          nome: item.nome,
          egress_id: item.id,
          checked: false,
        })),
    );
  }, [egresses, setCheckboxAll, state.id]);

  return (
    <>
      <TablePadrão
        thead={[
          <CheckBox
            checked={checked}
            disabled={loadEgress}
            type="checkbox"
            autoComplete="off"
            onChange={handleCheckedAll}
          />,
          'Nome',
          'Ações',
        ]}
        headWidth={headWidth}
      >
        {loadEgress && (
          <Tr>
            <Td width="100%">
              <SpinnerLoading />
            </Td>
          </Tr>
        )}

        {listEgresses?.map((item: any, i: React.Key | null | undefined) => (
          <TbodyGeralPageAddRoundsEgresses
            key={i}
            useStateEgresse={[egresse, setEgresse]}
            useStateIsOpen={[isWatchEgresse, setIsWatchEgresse]}
            itemEgresso={item}
            headWidth={headWidth}
            isCheckboxAll={checkboxAll}
            handleChecked={handleChecked}
            loadEgress={loadEgress}
          />
        ))}

        {egresses && (
          <Tr>
            <Td width="100%">
              <Pagination
                meta={egresses?.meta}
                setPage={handleSetEgresses}
                load={loadEgress}
              />
            </Td>
          </Tr>
        )}
      </TablePadrão>
    </>
  );
}

const CheckBox = styled.input`
  width: 15px;
  height: 15px;
`;
